// Global category constants for inventory items
export const INVENTORY_ITEM_CATEGORIES = [
  { value: 'Box', label: 'Box' },
  { value: 'Bag', label: 'Bag' },
  { value: 'Classic Mithai', label: 'Classic Mithai' },
  { value: 'Premium Mithai', label: 'Premium Mithai' },
  { value: 'Signature Mithai', label: 'Signature Mithai' },
  { value: 'Packaging Material', label: 'Packaging Material' },
  { value: 'Packaged Food Savoury', label: 'Packaged Food Savoury' },
  { value: 'Packaged Food Sweet', label: 'Packaged Food Sweet' },
  { value: 'Frozen Desserts', label: 'Frozen Desserts' },
  { value: 'Biscuits', label: 'Biscuits' },
  { value: 'Frozen Savories', label: 'Frozen Savories' },
  { value: 'Nimco', label: 'Nimco' },
  { value: 'Decoration', label: 'Decoration' },
  { value: 'Others', label: 'Others' }
];

// Helper function to get category options for dropdowns
export const getCategoryOptions = () => INVENTORY_ITEM_CATEGORIES;

// Helper function to get category values as array of strings
export const getCategoryValues = () => INVENTORY_ITEM_CATEGORIES.map(cat => cat.value);

// Helper function to check if a category exists
export const isValidCategory = (category: string) => 
  INVENTORY_ITEM_CATEGORIES.some(cat => cat.value === category);
